/**
 * HeroImage.jsx
 * Created by Destin Frasier on 12/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    heroImage: PropTypes.shape({
        backgroundImage: PropTypes.string
    }),
    ariaLabel: PropTypes.string
};

const defaultProps = {
    heroImage: { backgroundImage: `url(../img/sample_hero.jpg)` },
    ariaLabel: ''
};

export default class HeroImage extends React.PureComponent {
    render() {
        return (
            <div className="rec-hero-full-width-wrap" style={this.props.heroImage}>
                <div className="rec-hero-body-outer-wrap">
                    <div className="rec-hero-body">
                        <div className="rec-hero-body-main" role="img" aria-label={this.props.ariaLabel} />
                    </div>
                </div>
            </div>
        );
    }
}

HeroImage.propTypes = propTypes;
HeroImage.defaultProps = defaultProps;
